<template>
  <div class="upload uploadFile" :is_require="this.UpFile.is_require" :name="this.UpFile.name">
    <div class="load-bl">
      <h5 class="tit">
        {{this.UpFile.title}}
        <span v-show="this.UpFile.is_require == 1" style="color: #cf5454;margin-left: 5px;">*</span>
        <!-- <a href="javascript:void(0);">我已上传的<i class="icon-r"></i></a>-->
      </h5>
      <div class="uploa-bg">
        <div class="load-inner">
          <div v-if="MyUploadVideo.length>0" class="load-link load-over"  style="margin-bottom: 15px;" v-for="(item,ind) in MyUploadVideo">
            <div class="pic-b pic-v">
              <img :src="item.file.thumb_url" alt=""/>
            </div>
            <p :attr-uuid="item.file_id" attr-type="3" class="" style="padding-left: 10px">{{'文档'+(ind+1)}}</p>
          </div>

          <div class="load-link load-over videoFile2"  style="margin-bottom: 15px;" v-for="(item,ind) in fileName3">
            <span class="pic-del" @click="updateFile(ind)">×</span>
            <div class="pic-b pic-v">
              <!--头像修改成功！需要审核后才能生效-->
              <img src="/images/audit_2.jpg" alt=""/>
            </div>
            <p :attr-uuid="arrayUuid3[ind]" attr-type="3" class="fileName fileName3" style="padding-left: 10px">{{arrayName3[ind]}}</p>
            <!--   <span>上传成功！</span>-->
          </div>
          <div  id="videoContainer3" class="load-link">
            <div class="pic-b" id="selectVideo3">
              <input type="file" id="select3"/>
            </div>
          </div>
        </div>
        <p class="et-load-info et-file-info" :class="classObj" ref="p_info" @click="allTetx3" v-if="this.UpFile.tip">
          <span>[要求]</span>
          {{upfileTip}}
        </p>
        <p class="et-load-info et-file-info" @click="allTetx3" v-else>
          <span>[要求]</span>
          支持所有格式
        </p>
      </div>
    </div>
    <!--上传弹窗-->
    <div class="upload-modal large-info-modal modal fade" id="uploadModal3" data-backdrop="static" role="dialog"
         aria-hidden="false" style="background: rgba(0,0,0,.3)">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="top: 0">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <div class="group">
                  <label>名称<span>*</span></label>

                  <div class="pl-ipbox">
                    <input id="TextFile" type="text" placeholder="请输入名称" maxlength="20" />
                  </div>
                </div>
                <div class="group">
                  <label>描述<span>*</span></label>

                  <div class="pl-ipbox">
                    <textarea id="TextareaFile"  rows="3" placeholder="请输入描述信息,100字以内" maxlength="100"></textarea>
                  </div>
                </div>
                <a href="javascript:void(0);" class="btn-2 buttonW buttonR" @click="cancel3">取消</a>
                <a href="javascript:void(0);" class="btn-pl-start btn-pl-start3 buttonW buttonL">开始上传</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--提示-->
    <div class="upload-modal large-info-modal modal fade" id="uploadFile_al" data-backdrop="static" role="dialog"
         aria-hidden="false" style="background: rgba(0,0,0,.4)">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="top: 100px">
          <div class="modal-body">
            <p class="detailAlert-p Prompt-p">上传格式错误</p>
            <a href="javascript:void(0);" data-dismiss="modal" class="buttonZ">确定</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        props:[
            'UpFile',
            'id',
            'appId',
            'audit_level'
        ],
        data (){
            return {
                uptoken3: '',
                fileId3:'',
                fileName3: 0,
                arrayName3: [],
                arrayUuid3: [],
                arrayFile: [],
                allTyle3: false,
                key: '',
                numberSize: 0,
                MyUploadVideo: [],
                moreInfo: false,
                classObj: {
                    active: false,
                    'down-arrow':false,
                    all: false,
                    elips: false,
                },
                upfileTip:'',
            }
        },
        methods: {
            allTetx3(){
                if(!this.moreInfo) return;
                this.allTyle3 = !this.allTyle3
                if(this.allTyle3){
                    // $('.et-video-info').css('white-space','normal');
                    this.classObj = {
                        active: true,
                        'down-arrow':true,
                        all: true,
                        // elips: false,
                    }
                    this.upfileTip = this.UpFile.tip;

                }else{
                    // $('.et-video-info').css('white-space','nowrap');
                    this.classObj = {
                        active: false,
                        'down-arrow':true,
                        all: false,
                        // elips: true,
                    }
                    this.upfileTip = this.UpFile.tip.substr(0,50) + '...';
                }
            },
            //操作按钮事件
            Uptoken3(){
                var that = this
                this.$http.get(API.WorldToken,{params: {activity_id: that.$route.params.id,app_id: that.appId}})
                    .then(function (res) {
                        if(res.code == 1){
                            that.fileId3 = '';
                            that.uptoken3 = '';
                            that.key = '';
                        }else{
                            that.key = res.data.fileId;
                            that.fileId3 = res.data.fileId;
                            that.uptoken3  = res.data.uptoken
                        }
                    })
            },
            cancel3(){
                $('#uploadModal3').modal('hide');
                $('#Textvideo').val('');
                $('#Textareavideo').val('');
                $('#select').val('');
            },
            updateFile(idx){
                this.arrayUuid3.splice(idx, 1);
                this.arrayName3.splice(idx, 1);
                this.fileName3--;
                if(this.numberSize  > this.arrayName3.length + this.MyUploadVideo.length){
                    $('#videoContainer3').show();
                }
            },
            delFile(idx){
                this.fileName3--;
                this.arrayUuid3.splice(idx,1);
                this.arrayName3.splice(idx,1);
                if(this.UpFile.choose_num > this.arrayName3.length){
                    $('#videoContainer3').show();
                }
            },
            initMoreInfo(){
                var pinfo = this.$refs.p_info;
                if(pinfo){
                    var offH = pinfo.offsetHeight;
                    var scrollH = pinfo.scrollHeight;
                    // console.log(pinfo,offH,scrollH);
                    if(scrollH > offH){
                        this.moreInfo = true;
                        this.classObj = {
                            active: false,
                            all:false,
                            // elips:true,
                            'down-arrow':true,
                        }
                        this.upfileTip = this.UpFile.tip.substr(0,50) + '...';
                    }
                }
            },
        },
        created: function(){
            this.upfileTip = this.UpFile.tip;

        },
        mounted: function () {
            //操作DOM

            var that = this,
                subscription3;
            this.initMoreInfo();

            // if(this.UpFile.field_type == 'uploadfile'){
            if(that.UpFile.choose_num == '0'){
                $('.uploadFile').hide();
                return false
            }

            if(that.type != 0){
                that.ByUserid = {
                    file_type: 3,
                    activity_id: that.id
                };
                console.log("byuserID" ,that.ByUserid )
                this.$http.get(API.GetActivityFileByUserid, {params: that.ByUserid})
                    .then(function (res) {
                        //  console.log(res)
                        if (res.code == 0) {
                            for (var i = 0; i < res.data.length; i++) {
                                that.MyUploadVideo.push(res.data[i]);
                                // console.log(i)
                            }
                        }
                        console.log( that.MyUploadVideo);
                        that.arrayUuid3=[];
                        that.arrayName3=[];
                        that.fileName3=0;
                        if(!that.UpFile.choose_num){
                            that.numberSize = 1
                        }else{
                            that.numberSize =  that.UpFile.choose_num
                        }
                        if(that.numberSize == '' || that.numberSize == null || that.numberSize<= res.total){
                            $('#videoContainer3').hide();
                        }
                    });

            }else{
                that.numberSize = that.UpFile.choose_num;
            }
            // that.Uptoken3();
            // }

            $('#select3').change(function(){
                //$('#uploadModal3').modal('show');
                var file = this.files[0];  //文件
                var key = file.name;   //文件总名
                var name = key.split('.');//
                var ext = name[name.length-1].toLowerCase();

                //进度
                var next = function(response) {
                    var file = response;
                    //console.log(file);
                    var size = file.size/1024/1024;
                    var loaded = file.loaded/1024/1024
                    //总大小
                    $('.SizeBox').html(size.toFixed(2));
                    //已上传
                    $('.SecondBox').html(loaded.toFixed(2));
                    //上传进度
                    $('.pl-num').children('span').html(file.percent.toFixed(2));
                    //上传进度条
                    $('.pl-gro-bar').css('width',file.percent + '%');
                };
                //保错
                var error = function(err) {
                    console.log(err);
                    $('#processModal').modal('hide');
                    $('#uploadFile_al .detailAlert-p').html('上传出错');
                    $('#uploadFile_al').modal('show');
                    $('#select3').val('');
                };
                //上传成功
                var complete = function(isSuccess ,code , backData) {
                    if(isSuccess){
                        var userData = JSON.parse(ALY.util.base64.decode(backData.userData)).Vod.UserData;

                        // var obj = document.getElementById('select3') ;
                        // obj.value = '';
                        // obj.outerHTML=obj.outerHTML;
                        // that.Uptoken3();
                        ++that.fileName3;
                        that.arrayUuid3.push(userData.file_id);
                        that.arrayName3.push(key);
                        $('#TextFile').attr('value','');
                        $('#TextareaFile').attr('value','');
                        $('#select3').val('');
                        $('#processModal').modal('hide');
                        if(that.numberSize  <= that.arrayName3.length + that.MyUploadVideo.length){
                            // if(that.UpFile.choose_num <= that.arrayName3.length){
                            $('#videoContainer3').hide();
                        }
                    }else{
                        $('#processModal').modal('hide');
                        $('#TextFile').attr('value','');
                        $('#TextareaFile').attr('value','');
                        $('#select3').val('');
                        $('#uploadFile_al .detailAlert-p').html(backData);
                        $('#uploadFile_al').modal('show');
                    }
                };
                var params = {}
                //上传
                if(that.$route.params.id == 0){
                    params.activity_id = that.id;
                }else{
                    params.activity_id = that.$route.params.id || that.id;
                }

                params.source = "1";
                params.app_id = that.appId;
                params.audit_level = that.audit_level;
                console.log("fileupload" + params.audit_level);
                var content = {
                    file: file,          //文件名 必填
                    file_type:"3",
                    Biography: params
                };
                $('#processModal').modal('show');
                $.fn.uploadHandle(content,function () {
                    console.log("开始上传！");
                },next, complete);
                // $('.btn-pl-start3').on('click', function () {
                // if ($('#TextFile').val().trim() == '') {
                //   $('#TextFile').focus()
                // } else if ($('#TextareaFile').val().trim() == '') {
                //   $('#TextareaFile').focus()
                // } else {
                //
                // }
            });
            //取消
            $('.btn-pl-giveup').unbind('click').on('click', function () {
                $.fn.stopUploadFile();
                $.fn.cancleUploadFile();
                $.fn.deleteUploadFile();
                $('#TextFile').attr('value','');
                $('#TextareaFile').attr('value','');
                $('#select3').val('');
                var obj = document.getElementById('select3') ;
                obj.value = '';
                obj.outerHTML=obj.outerHTML;
            });
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/UploadToken/FileUpload.vue